// @flow

// Vendors
import React, { useState } from 'react';

// Components
import { Form, FormField, FormSubmit, CheckboxList, Notice } from '..';

// Requests
import { updateUserRequest, forgotPasswordRequest } from '../../requests';

const EditUserForm = () => {
  const { user, emailPreferencesOptions } = window;
  const [success, setSuccess] = useState('');
  const [passwordResetMessage, setPasswordResetMessage] = useState({});
  const [sendingPasswordReset, setSendingPasswordReset] = useState(false);

  const initialValues = {
    id: user.id || '',
    firstName: user.first_name || '',
    lastName: user.last_name || '',
    jobTitle: user.job_title || '',
    emailPreferencesUpdates: user.email_preferences_updates,
    emailPreferencesMarketing: user.email_preferences_marketing || []
  };

  const handleChangePasswordClick = ({ setSubmitting, setErrors }) => {
    setSendingPasswordReset(true);
    setPasswordResetMessage({});

    return forgotPasswordRequest({ email: user.email })
      .then(({ data }) => {
        setSendingPasswordReset(false);

        setPasswordResetMessage({
          type: 'success',
          message: 'A password reset link has been sent to your email address.'
        });
      })
      .catch(({ data }) => {
        setSendingPasswordReset(false);

        if (data.errors.email || data.errors.formError)
          setPasswordResetMessage({
            type: 'danger',
            message: data.errors.email || data.errors.formError
          });
      });
  };

  const handleSubmit = ({
    values,
    errors,
    setValues,
    setErrors,
    setSubmitting
  }) => {
    setSubmitting(true);
    updateUserRequest(values)
      .then(response => {
        setSuccess('User successfully updated.');
        setSubmitting(false);
      })
      .catch(({ data }) => {
        setSubmitting(false);
        if (data.errors) setErrors(data.errors);
      });
  };

  return (
    <Form
      className="account-form card"
      onSubmit={handleSubmit}
      initialValues={initialValues}
      render={({
        values,
        errors,
        isSubmitting,
        setSubmitting,
        handleChange,
        setValue,
        setError,
        setErrors
      }) => (
        <>
          <div className="card__section">
            <h4>Personal Details</h4>

            <FormField
              name="firstName"
              label="First Name"
              onChange={handleChange}
              value={values.firstName}
              error={errors.firstName}
              disabled={isSubmitting}
            />
            <FormField
              name="lastName"
              label="Last Name"
              onChange={handleChange}
              value={values.lastName}
              error={errors.lastName}
              disabled={isSubmitting}
            />
            <FormField
              name="jobTitle"
              label="Job Title"
              onChange={handleChange}
              value={values.jobTitle}
              error={errors.jobTitle}
              disabled={isSubmitting}
            />
          </div>

          <hr className="u--margin-0" />

          <div className="card__section">
            <h4>Organization Details</h4>

            <FormField
              name="organizationName"
              label="Organization Name"
              value={user.organization_name}
              disabled={true}
            />
            <FormField
              name="organizationType"
              label="Organization Type"
              value={user.organization_type_label}
              disabled={true}
            />
          </div>

          <hr className="u--margin-0" />

          <div className="card__section">
            <h4>Email Preferences</h4>

            <h5>Resource Center Updates</h5>
            <FormField
              name="emailPreferencesUpdates"
              label="I would like to receive notifications when documents are added or updated within the Telecor Resource Center."
              type="emailPreferencesUpdates"
              type="checkbox"
              onChange={handleChange}
              value={values.emailPreferencesUpdates}
              error={errors.emailPreferencesUpdates}
              disabled={isSubmitting}
              checked={
                values.emailPreferencesUpdates &&
                values.emailPreferencesUpdates !== '0'
                  ? true
                  : false
              }
            />

            <h5>Marketing Emails</h5>
            <CheckboxList
              options={emailPreferencesOptions}
              parentFieldName="emailPreferencesMarketing"
              onChange={handleChange}
              values={values}
              setValue={setValue}
              disabled={isSubmitting}
            />
          </div>

          <hr className="u--margin-0" />

          <div className="card__section">
            <h4>Account Details</h4>

            <FormField
              name="email"
              label="Email"
              type="email"
              value={user.email}
              disabled={true}
            />
            <FormField
              name="password"
              label="Password"
              type="password"
              value="**********"
              disabled={true}
            />
            <div>
              <button
                type="button"
                className="btn btn--link u--padding-0 u--margin-top-0 u--border-width-0"
                disabled={sendingPasswordReset}
                onClick={() =>
                  handleChangePasswordClick({ setSubmitting, setErrors })
                }
              >
                Change Password
              </button>
              <p className="small">
                Note: Users who wish to update their password will be sent an
                email to the email address listed above with a link to create a
                new password.
              </p>
            </div>
            {passwordResetMessage.message && (
              <Notice
                {...passwordResetMessage}
                dismiss={() => setPasswordResetMessage({})}
              />
            )}
          </div>

          <hr className="u--margin-0" />

          <div className="card__section">
            <FormSubmit
              loading={isSubmitting}
              disabled={isSubmitting}
              disabledLabel={
                isSubmitting && !success ? 'Submitting...' : 'Submit'
              }
            />
            {errors.formError && (
              <Notice
                type="danger"
                message={errors.formError}
                dismiss={() => setError('formError', '')}
              />
            )}
            {success && (
              <Notice
                type="success"
                message={success}
                dismiss={() => setSuccess('')}
              />
            )}
          </div>
        </>
      )}
    />
  );
};

export default EditUserForm;
